export const PIN_ENGAGEMENT = 'PIN_ENGAGEMENT';
export const UNPIN_ENGAGEMENT = 'UNPIN_ENGAGEMENT';
export const PINNED_ENGAGEMENT_UPDATED = 'PINNED_ENGAGEMENT_UPDATED';